import Form from 'react-bootstrap/Form';
import { useState, useEffect } from "react";
import '../../../css/SelectProductQty.css';
import StocknameConverter from '../../converter/StocknameConverter.js';

function SelectProductQtyMulti(props) {
  const [itemsChecked, setItemsChecked] = useState([]);
  const [scanInput, setScanInput] = useState("");
  const [primarySelection, setPrimarySelection] = useState("");
  const exceedQty = 1;

  const ClearItemsChecked = () => {
    for (let i = 0; i < props.item_Details.length; i++) 
    {
        const item = props.item_Details[i];
        item.SelectedQty = 0;
    }
    setItemsChecked([]);
    setPrimarySelection("");
  }
  props.passClearSelectedItems(ClearItemsChecked);

  const SelectQtyChange = (e) => {
    let itemChecked = FindArrayElementByItemCode(itemsChecked, e.target.name);
   // console.log("e.target.name: " + e.target.name);

    setPrimarySelection(e.target.name);

    let newitemsChecked = [...itemsChecked]; 
    if (typeof(itemChecked) !== 'undefined' && itemChecked != null) {
      for (var i = 0; i < newitemsChecked.length; i++) {
        if (newitemsChecked[i].Item_Code == e.target.name) {
          newitemsChecked[i].value = e.target.value;
        }
      }
    } else {
      newitemsChecked = newitemsChecked.concat({ Item_Code: e.target.name, value: e.target.value });
    }
    setItemsChecked(newitemsChecked);
    props.setItemQty(e.target.name, e.target.value);
  }

  //console.log("primarySelection: " + primarySelection);

  const handleKeyPress = (e) => {
    if (e.charCode == 13) {
      let item = FindArrayElementByItemCode(props.item_Details, scanInput);
      if (typeof(item) !== 'undefined' && item != null) {
        let itemChecked = FindArrayElementByItemCode(itemsChecked, scanInput);
        let newitemsChecked = [...itemsChecked]; 
        if (typeof(itemChecked) !== 'undefined' && itemChecked != null) {
          for (var i = 0; i < newitemsChecked.length; i++) {
            if (newitemsChecked[i].Item_Code == item.Item_Code) {
              if (parseInt(newitemsChecked[i].value, 10) < item.Item_Max_Qty) {
                newitemsChecked[i].value = parseInt(newitemsChecked[i].value, 10) + 1;
                props.setItemQty(item.Item_Code, newitemsChecked[i].value);
              } else {
                alert("已到達上限");
              }
            }
          }
        } else {
          newitemsChecked = newitemsChecked.concat({ Item_Code: item.Item_Code, value: 1 });
          props.setItemQty(item.Item_Code, 1);
        }
        setItemsChecked(newitemsChecked);
        setScanInput("");
      } else {
        alert("貨品不存在");
        setScanInput("");
      }
    } 
  }

  const onChange = (e) => {
    setScanInput(e.target.value);
  }

  // Group items by Pickup_Group
  const groupedItems = props.item_Details.reduce((groups, item) => {
    const group = groups[item.Pickup_Group] || [];
    group.push(item);
    groups[item.Pickup_Group] = group;
    return groups;
  }, {});

  // Sort each group by Pickup_Order
  Object.keys(groupedItems).forEach((group) => {
    groupedItems[group].sort((a, b) => a.Pickup_Order - b.Pickup_Order);
  });

  // Calculate total quantity and subtotal for each Pickup_Group
  const groupTotals = Object.keys(groupedItems).reduce((totals, group) => {
    const totalQty = groupedItems[group].reduce((sum, item) => sum + (parseInt(item.SelectedQty) || 0), 0);
    const subtotal = groupedItems[group].reduce((sum, item) => sum + (item.SubTotal || 0), 0);
    totals[group] = { totalQty, subtotal };
    return totals;
    }, 
  {});

  const purchasedGroups = new Set();
    props.item_Details.forEach(item => {
      if (item.Is_Purchased) {
        purchasedGroups.add(item.Pickup_Group);
      }
    });

  // Calculate remaining quantity allowed for each Pickup_Group
  const remainingQty = Object.keys(groupedItems).reduce((remaining, group) => {
    const totalQty = groupTotals[group].totalQty;
    remaining[group] = exceedQty - totalQty;
    return remaining;
    }, 
  {});

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Control type="text" onKeyPress={handleKeyPress} onInput={onChange} value={scanInput} hidden={!props.isShowScanInput} />
        <br />
        {Object.keys(groupedItems).map((group) => (
          <div key={group}>
            {/*<h5>{group}</h5>*/}
            {groupedItems[group].map((item) => (
              <div key={item.Item_Code}>
                <div className="divFlexHeader">
                  {/* [{item.Pickup_Group}]
                  [{item.Pickup_Order}]
                  [{item.Item_Code}] */}
                  <div className="divFlexRight">
                    {
                   /* purchasedGroups.has(item.Pickup_Group) ? (
                    //  <span>
                    //    <del><StocknameConverter itemname={item.Item_Name}></StocknameConverter></del>
                    //    <span className="soldOut"> 此期數曾經購買</span>
                   //   </span>
                    ) : */
                    !item.Is_Available ? (
                      <span>
                        <del><StocknameConverter itemname={item.Item_Name}></StocknameConverter></del>
                        <span className="soldOut"> 已滿額</span>
                      </span>
                    ) : (
                      <span>
                        <StocknameConverter itemname={item.Item_Name} itemspec={item.Item_Spec}></StocknameConverter>  
                        {/* <span>{item.Item_Spec}</span> */}
                      </span>
                    )}
                  </div>
                  {/*<div>HK$ {item.Item_ActualPrice}</div>*/}
                </div>
                <PrintRadio
                  groupName={item.Item_Code}
                  key={item.Item_Code}
                  Item_Min_Qty={item.Item_Min_Qty}
                  Item_Max_Qty={item.Item_Max_Qty}
                  description={item.Item_Name}
                  value={item.Item_Code}
                  passEvent={SelectQtyChange}
                  itemsChecked={itemsChecked}
                  itemsAvailable={item.Is_Available}
                  itemsPurchased={purchasedGroups.has(item.Pickup_Group)}
                  primarySelection={primarySelection}
                />
                <br />
                {/* <div className="divFlexHeader">
                  <div className="divFlexRight">小計</div>
                  <div>HK$ {item.SubTotal}</div>
                </div> */}
                <br />
              </div>
            ))}
           {/*} <div className="divFlexHeader">
              <div className="divFlexRight">小計</div>
              <div>HK$ {groupTotals[group].subtotal}</div>
            </div> */}
            {groupTotals[group].totalQty > exceedQty && (
              <div className="warning">
                * 只可選擇一個場次
                &nbsp; 
              </div>
            )}
            <button type="button" onClick={ClearItemsChecked}>重置</button>
            <hr /> {/* Divider for each Pickup_Group */}
          </div>
        ))}
         {/*<div className="divFlexHeader"> 
        <div className="divFlexRight">
            總計-
          </div>                                    
          <div>
            HK$ {props.totalAmount}
          </div>                          
        </div> */}
      </Form.Group>
    </>
  );
}

function PrintRadio(props){
    const arr = new Array();
    for (var i=props.Item_Min_Qty;i<=props.Item_Max_Qty;i++)
    {
      arr.push(i);
    }

    //Added by Joanne 20250703 handle only option
    var lblItem ;
   // console.log("AA- props.primarySelection: "+ props.primarySelection);
    //console.log("BB- props.groupName: "+ props.groupName);
    
    if (props.Item_Min_Qty === props.Item_Max_Qty)
    {
      if (props.itemsPurchased || !props.itemsAvailable){
        return arr.map((i) => <Form.Check inline="true" type="radio" name={props.groupName} key={props.groupName+i} checked={false} label="✔" value={i} onChange={ e => {  props.passEvent(e)}} disabled={true} ></Form.Check>)
      } else {
        return arr.map((i) => <Form.Check inline="true" type="radio" name={props.groupName} key={props.groupName+i} checked={(FindCheckedValue(props.itemsChecked,props.groupName)) == i} label="✔" value={i} onChange={ e => {  props.passEvent(e)}} disabled={!(props.primarySelection ===  props.groupName || props.primarySelection === "")} ></Form.Check>)
      }
    }
    else
    {
      if (props.itemsPurchased || !props.itemsAvailable){
        return arr.map((i) => <Form.Check inline="true" type="radio" name={props.groupName} key={props.groupName+i} checked={false} label={i} value={i} onChange={ e => {  props.passEvent(e)}} disabled={true} ></Form.Check>)
      } else {
        return arr.map((i) => <Form.Check inline="true" type="radio" name={props.groupName} key={props.groupName+i} checked={(FindCheckedValue(props.itemsChecked,props.groupName)) == i} label={i} value={i} onChange={ e => {  props.passEvent(e)}} disabled={false} ></Form.Check>)
      }
    }
  }

function FindArrayElementByValue(array, value) {
    return array.find((element) => {
      return element.value === value;
    })
  }

function FindArrayElementByItemCode(array, value) {
  return array.find((element) => {
    return element.Item_Code === value;
  })
}

function FindCheckedValue(array, value) {
  let item = FindArrayElementByItemCode(array, value);
  if (typeof(item) !== 'undefined' && item != null) {
    return item.value;
  }
  return null;
}

export default SelectProductQtyMulti;
